import { useState } from "react";

export default function Subscribe() {
  const [done, setDone] = useState(false);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-2xl border border-primary-200 bg-primary-900 px-6 py-10 md:px-10 md:py-12">
          <div className="pointer-events-none absolute -right-8 -top-10 h-56 w-56 rounded-full bg-accent-500/20 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-12 left-10 h-48 w-48 rounded-full bg-primary-600/30 blur-2xl" />

          <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
            <div>
              <p className="inline-flex items-center gap-2 rounded-full bg-primary-700/70 px-3 py-1 text-xs font-semibold text-accent-200">
                <i className="ri-notification-3-line" />
                追更提醒 · 盯住就不落下
              </p>
              <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
                后续发展不落下，
                <br className="hidden sm:block" />
                有新进展第一时间告诉你
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-7 text-background-200">
                留下一串联系方式，当跟进的线索出现新转折、官方做出回应或证据更新时，我们会把最新进展推送到你手上。
              </p>
            </div>

            <div>
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  className="h-12 flex-1 rounded-md border border-background-700/70 bg-primary-950/60 px-4 text-sm text-background-50 outline-none placeholder:text-background-400 focus:border-accent-400"
                  placeholder="输入邮箱或手机号"
                />
                <button
                  type="button"
                  onClick={() => setDone(true)}
                  className="h-12 whitespace-nowrap rounded-md bg-accent-500 px-5 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  设置追更提醒
                </button>
              </div>
              <p className="mt-3 min-h-[20px] text-xs leading-5 text-background-300">
                {done ? "已收到你的追更请求（演示提示，未接入真实发送）。" : "可随时取消，我们只在你关心的线更新时触达。"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}